import React from 'react';
import useFetchRoomData from '../hooks/useFetchRoomData';
import Room from "./Room";

const RoomList = ({ floor }) => {
    const { rooms, loading } = useFetchRoomData(floor);

    if (loading) return <p>Loading...</p>;

    return (
        <div className="content">
            <div className="room-list__container_wrapper">
                {rooms?.WarnRooms?.length > 0 && (
                    <div className="room-list__warning">
                        <div className="room-list__container">
                            {rooms.WarnRooms.map((room) => (
                                <Room key={room.id} {...room} />
                            ))}
                        </div>
                    </div>
                )}
                <div className="room-list__container">
                    {rooms?.Rooms?.map((room) => (
                        <Room key={room.id} {...room} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default RoomList;
